import * as React from 'react';

import stylesVariables from '../../../components/_variables.scss';

import PeopleSectionComponent, {
  FlippedCards,
  PersonKeys,
} from '../../../components/AboutPage/PeopleSection/PeopleSection';
import { PeopleSectionLocale } from '../../../components/AboutPage/PeopleSection/peopleSection.locale';

interface PeopleSectionProps {
  locale: PeopleSectionLocale;
}

interface PeopleSectionState {
  flippedCards: FlippedCards;
}

class PeopleSection extends React.PureComponent<PeopleSectionProps, PeopleSectionState> {
  state = {
    flippedCards: {},
  };

  flipCard = (key: PersonKeys) =>
    window.innerWidth < parseInt(stylesVariables['sm-breakpoint'], 10) &&
    this.setState(prevState => ({
      flippedCards: {
        ...prevState.flippedCards,
        [key]: prevState.flippedCards[key] ? !prevState.flippedCards[key] : true,
      },
    }));

  render() {
    return (
      <PeopleSectionComponent
        locale={this.props.locale}
        flippedCards={this.state.flippedCards}
        flipCard={this.flipCard}
      />
    );
  }
}

export default PeopleSection;



// WEBPACK FOOTER //
// /www/client/src/containers/AboutPage/PeopleSection/PeopleSection.tsx